module.exports = __webpack_public_path__ + "static/img/video-5.c431c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-5.jpg
// module id = RUeT
// module chunks = 13